var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 55,
    viewBox: "0 0 19 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18053 24.3599V53.5912",
    stroke: "#3290EC",
    strokeWidth: 1.96357,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.93 3.93"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1348,
    cy: 9.1348,
    r: 6.18944,
    stroke: "#3290EC",
    strokeWidth: 5.89072
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cac2ebfba7c89c69cf40cca7b44c7507.svg";
export { ForwardRef as ReactComponent };